module.exports = __webpack_public_path__ + "static/media/3.69ae3ea9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/Artists/02/projects/01/3.jpg
// module id = 405
// module chunks = 0